// extracted by css-extract-rspack-plugin
var _1 = "change-log-table-IzBeNN";
var _2 = "change-log-table-IzBeNN";
var _3 = "class-tag-Z80WZV";
var _4 = "class-tag-interactive-iIFw7S";
var _5 = "class-tag-Z80WZV";
var _6 = "class-tag-interactive-iIFw7S";
var _7 = "column-source-_mACrZ";
var _8 = "column-source-_mACrZ";
var _9 = "description-yoAYdG";
var _a = "descriptions-s7gqh3";
var _b = "diff-ULDvSQ";
var _c = "nested-descriptions-n8QyfD";
var _d = "nested-descriptions-n8QyfD";
var _e = "related-items-form-FdHKva";
var _f = "related-items-table-eTY6H9";
var _10 = "related-items-form-FdHKva";
var _11 = "related-items-table-eTY6H9";
var _12 = "ticket-alert-vQV8Tt";
var _13 = "ticket-alert-vQV8Tt";
var _14 = "vote-ozhYqW";
export { _1 as "change-log-table", _2 as "changeLogTable", _3 as "class-tag", _4 as "class-tag-interactive", _5 as "classTag", _6 as "classTagInteractive", _7 as "column-source", _8 as "columnSource", _9 as "description", _a as "descriptions", _b as "diff", _c as "nested-descriptions", _d as "nestedDescriptions", _e as "related-items-form", _f as "related-items-table", _10 as "relatedItemsForm", _11 as "relatedItemsTable", _12 as "ticket-alert", _13 as "ticketAlert", _14 as "vote" }
